import { useTranslations } from 'next-intl';
import { Wrapper } from '../../shared/wrapper';
import { FC, memo, useState } from 'react';
import LazyImage from '../LazyImage';
import { styled } from '../../shared/styles';
import { LockOutlined as LockOutlineIcon } from '@mui/icons-material';
import { AuditsModal } from '../../shared/AuditsModal';

let Footer: FC<{ className?: string }> = ({ className }) => {
  const t = useTranslations();
  const [isAuditsModalOpened, setIsAuditsModalOpened] = useState(false);
  const openPdf = (fileName: string) => {
    const url = '/' + fileName;
    const win = window.open(url, '_blank');
    if (win) win.focus();
  };

  return (
    <footer className={className}>
      <Wrapper className='footer_container'>
        <div className='footer_block'>
          <div className='flex logo_wrapper'>
            <LazyImage src='/images/icons/landing/logo_h.png' alt='logo' />
            Magnet 2025 ©. {t('footer.rights')}
          </div>
          <div className='flex privacy_wrapper'>
            {/* <a href='/' target='_blank'>
              <span>{t('footer.rools')}</span>
            </a>
            <div className='splitter'></div>
            <a href='/' target='_blank'>
              <span>{t('footer.privacy')}</span>
            </a>{' '} */}
            {/* <div className='splitter'></div> */}
            <span style={{ cursor: 'pointer' }} onClick={() => openPdf('terms_of_use_magnet.pdf')}>
              <span>{t('footer.terms')}</span>
            </span>{' '}
            <div className='splitter'></div>
            <div className='audit' style={{ cursor: 'pointer' }} onClick={() => setIsAuditsModalOpened(true)}>
              <LockOutlineIcon />
              <span>{t('footer.audit.short')}</span>
            </div>
          </div>
        </div>
        <div className='flex icons_wrapper'>
          <a href='https://t.me/Magnet_Official_Channel' target='_blank'>
            <LazyImage src='/images/icons/landing/telegram.svg' alt='telegram' />
          </a>
          <a target='_blank' style={{ opacity: 0.5 }}>
            <LazyImage src='/images/icons/landing/x.svg' alt='x' />
            <span style={{ opacity: 0.7, fontSize: '14px', color: 'white' }}>{t('footer.coming_soon')}</span>
          </a>
          <a href='https://www.youtube.com/@World-Magnet' target='_blank'>
            <LazyImage src='/images/icons/landing/youtube.svg' alt='youtube' />
          </a>
        </div>
      </Wrapper>
      <AuditsModal isOpened={isAuditsModalOpened} onClose={() => setIsAuditsModalOpened(false)} />
    </footer>
  );
};

Footer = styled(Footer, {
  '& .footer_container': {
    marginTop: '200px',
    padding: '32px 40px',
    justifyContent: 'space-between',
    display: 'flex',
    borderTop: '1px solid #34384c',

    '@toDesktop': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      rowGap: '32px'
    },

    '@toTabletPortrait': {
      display: 'grid',
      gridTemplateColumns: '1fr',
      rowGap: '26px',
      padding: '32px 20px'
    },
    '@toMediumLandscape': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      rowGap: '32px'
    }
  },
  '& .audit': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px'
  },
  '& .splitter': {
    height: '24px',
    width: '1px',
    backgroundColor: '#34384c',

    '@toTablet': {
      height: '1px',
      width: '140px',
      display: 'none'
    }
  },
  '& .logo_wrapper': {
    gap: '12px',
    color: '#afa5b8',

    img: {
      filter: 'grayscale(100%)'
    },
    justifyContent: 'start'
  },

  '& .icons_wrapper': {
    gap: '25px',
    marginLeft: 'auto',

    a: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    '@toTablet': {
      margin: '0 auto'
    }
  },
  '& .privacy_wrapper': {
    display: 'flex',
    gap: '20px',

    span: {
      fontSize: '16px',
      lineHeight: '24px',
      color: '#afa5b8',

      '&:hover': {
        textDecoration: 'underline'
      }
    },
    '& .no_hover': {
      span: {
        '&:hover': {
          cursor: 'auto',
          textDecoration: 'none'
        }
      }
    },

    '@toTablet': {
      flexDirection: 'column'
    }
  },
  '& .soc': {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '30px'
  },

  '& .footer_block': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  }
});

export default memo(Footer);
